import { DTO__image_segment_for_render } from './DTO__image_segment_for_render';

export class DTO__image_segment_for_render_collection {
  static EMPTY = new DTO__image_segment_for_render_collection();

  static CREATE(segments: DTO__image_segment_for_render[], width: number, height: number) {
    let out = new DTO__image_segment_for_render_collection();
    out.segments = segments;
    out.width = width;
    out.height = height;

    return out;
  }

  /*
   * FIELDS
   */

  //change to MAP
  segments: DTO__image_segment_for_render[];
  width: number;
  height: number;

  constructor() {
    this.segments = [];
    this.width = 0;
    this.height = 0;
  }
}
